<template>
  <div class="custom-container" v-loading.fullscreen.lock="user.isLoading">
    <el-row>
      <el-row type="flex" align="center" class="my-4" justify="space-between">
        <el-col :span="5">
          <div class="category-title">Edit Staff Account</div>
        </el-col>
        <el-col :span="4">
          <el-row type="flex" justify="end">
            <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
            <el-button size="small" type="primary" @click="save">Simpan</el-button>
          </el-row>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-form label-position="left" ref="adminOrStaff" label-width="120px" :model="user.data">
          <Form :AdminAndStaff="user.data" from="edit"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    Form
  },
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapState({
      user: state => state.user.adminOrStaff
    })
  },
  methods: {
    ...mapActions({
      getUser: "user/GetUser",
      updateUser: "user/UpdateUser"
    }),
    save() {
      this.$refs.adminOrStaff.validate(valid => {
        if (valid) {
          this.updateUser(this.user.data);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.getUser(this.id);
  }
};
</script>

<style>
</style>
